export const VARIANTS_KEYS = [
  'variantA',
  'variantB',
  'variantC',
  'variantD',
  'variantE',
  'variantF',
  'variantG',
  'variantH',
  'variantI',
  'variantJ',
] as const

export const REPORTED_KEY_VALUES = [
  'ver_a',
  'ver_b',
  'ver_c',
  'ver_d',
  'ver_e',
  'ver_f',
  'ver_g',
  'ver_h',
  'ver_i',
  'ver_j',
] as const
export type ReportedKeyValue = (typeof REPORTED_KEY_VALUES)[number]

export const REPORTED_KEY_VALUE_MAP: Record<(typeof VARIANTS_KEYS)[number], ReportedKeyValue> = {
  variantA: 'ver_a',
  variantB: 'ver_b',
  variantC: 'ver_c',
  variantD: 'ver_d',
  variantE: 'ver_e',
  variantF: 'ver_f',
  variantG: 'ver_g',
  variantH: 'ver_h',
  variantI: 'ver_i',
  variantJ: 'ver_j',
} as const
